import { render } from "./DragToUpload.vue?vue&type=template&id=de816dc8"
import script from "./DragToUpload.vue?vue&type=script&lang=js"
export * from "./DragToUpload.vue?vue&type=script&lang=js"
script.render = render

export default script